/* eslint-disable jsx-a11y/anchor-is-valid */
import {Component, render} from "react";
import {connect} from "react-redux";
import {
    set_datapage,
    SetLanguage,
    getLanguage,
} from "../redux/actions/DataPageAction";
import MapGoogle from "views/util/MapGoogle";
import estilosGoogleMaps from "views/util/EstilosGoogleMaps";

import "css/frontend/generals.scss";
import "css/frontend/index.css";
import {baseUrl, localUrl} from "@ora/recursos/src/helpers/Url";
import axios from "axios";
import "css/reportes/scrollbar.css";
import {Chart} from "react-google-charts";
import {Helpers} from "@ora/recursos";
import ElementoImagenRandom from "./InicioFrontend/ElementoImagenRandom";

let {getAuthorization} = Helpers.ValidationAuth;

class SectionImagenRandom extends Component {

    render() {
        if (this.props.data) {
            const itemElementoImagenRandom = this.props.data.map((item, index) => {
                return <ElementoImagenRandom key={index} data={item}></ElementoImagenRandom>;
            });
            return (
                <div className="columns columns-images-random jsoft-grey-light-bg jsoft-content-animals">
                    {itemElementoImagenRandom}
                </div>
            );
        } else {
            return <div className="columns"></div>;
        }
    }
}

class ElementoTablaScrollX extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <tr>
                <td width="15%">
                    <img
                        src={baseUrl(
                            "imagen/cites/" + this.props.item.duc_txt_format + ".png"
                        )}
                        width="50"
                        height="50"
                    ></img>
                </td>
                <td width="95%">
                    <p className="nombreDocumentoScrollBar">
                        <a
                            className="jsoft-title-item"
                            href={localUrl(
                                "/documento/" + this.props.item.duc_int_id,
                                "amazoniadigital"
                            )}
                        >
                            {this.props.item.duc_txt_title.substr(0, 100) + "..."}{" "}
                        </a>
                    </p>
                    <p className="nombreAutorScrollBar">
            <span className="icon is-small is-right jsoft-cyan">
              <i className="fa fa-user"></i>
            </span>
                        <strong className="jsoft-cyan">
                            {" "}
                            {this.props.language("index_autor")}{" "}
                        </strong>
                        <i>{this.props.item.duc_txt_creator}</i>
                    </p>

                    <p className="fechaPubScrollBar">
            <span className="icon is-small is-right jsoft-cyan">
              <i className="fa fa-calendar"></i>
            </span>
                        <strong className="jsoft-cyan">
                            {" "}
                            {this.props.language("index_publicado")}{" "}
                        </strong>{" "}
                        {this.props.item.duc_txt_date}
                    </p>
                </td>
            </tr>
        );
    }
}

class ColumnScrollBarX extends Component {
    constructor(props) {
        super(props);
        this.state = {
            "Documentos Recientes": "R",
            "Documentos Jurídicos": "DJ",
            DENPs: "D",
            valorBusqueda: "",
            parametrosBusqueda: {t: ""},
        };
        this.handleBusqueda = this.handleBusqueda.bind(this);
        var url = baseUrl(
            `cites/reportes/getdocfrontend?l=25&o=0&t=` +
            this.state[this.props.categoria]
        );

        axios.get(url).then((res) => {
            this.cargarElementosScroll(res.data);
        });
    }

    generarParametrosURL(inputArrayAux = {index: null, value: null}) {
        let urlParams = "";
        let arrayParams = this.state.parametrosBusqueda;

        Object.entries(arrayParams).forEach((element, index) => {
            if (inputArrayAux.index === element[0]) {
                element[1] = inputArrayAux.value;
            }

            if (element[1] !== "")
                if (index !== arrayParams.length - 1) {
                    urlParams += element[0] + "=" + element[1] + "&";
                } else {
                    urlParams += element[0] + "=" + element[1];
                }
        });
        return urlParams;
    }

    cambiarParametrosBusqueda(arrayParams) {
        Object.entries(arrayParams).forEach((element, index) => {
            if (element[0] !== "") {
                let items = this.state.parametrosBusqueda;
                items[element[0]] = element[1].replace(/-/g, " ");

                this.setState({parametrosBusqueda: items});
            }
        });
    }

    cargarElementosScroll(elementos) {
        const listaElementos = elementos.map((item, index) => {
            return <ElementoTablaScroll item={item} key={index}/>;
        });

        //this.setState({listaElementos : listaElementos})
        this.setState({
            listaElementos: listaElementos,
        });
    }

    buscar_simple = () => {
        this.cambiarParametrosBusqueda({t: this.state.valorBusqueda});
        var url = localUrl("?" + this.generarParametrosURL(), "amazoniadigital");

        //this.props.history.push(localUrl(url))
        window.location.assign(url);
    };

    handleBusqueda(e) {
        const value = e.target.value.replace(/ /g, "-");
        this.setState({
            valorBusqueda: value,
        });
    }

    render() {
        let url;
        let name;
        if (this.props.categoria === "Documentos Recientes") {
            url = localUrl("?module=cites", "amazoniadigital");
            name = this.props.language("index_documentoreciente", "Docu");
        }
        if (this.props.categoria === "Documentos Jurídicos") {
            url = localUrl("?tp=Certificado-CITES", "amazoniadigital");
            name = this.props.language("index_docjuridicos", "juri");
        }
        if (this.props.categoria === "DENPs") {
            url = localUrl("?tp=DENPS-especies", "amazoniadigital");
            name = "DENPS";
        }
        return (
            <div className="column jsoft-pd-t-50">
                <div className="card pb-3 jsoft-bd-0">
                    {/* <header className="card-header jsoft-card-header-index ">
                    <p className="jsoft-card-header-title"> */}
                    <header className="jsoft-card-header-index ">
                        {this.props.categoria === "Documentos Recientes" ? (
                            <>
                                <p className="card-header-title jsoft-card-titulo-index  jsoft-title-md jsoft-green jsoft-pad-0">
                                    {name}
                                </p>
                            </>
                        ) : (
                            ""
                        )}
                        {this.props.categoria === "Documentos Jurídicos" ? (
                            <>
                                <p className="card-header-title jsoft-card-titulo-index  jsoft-title-md jsoft-red jsoft-pad-0">
                                    {name}
                                </p>
                            </>
                        ) : (
                            ""
                        )}
                        {this.props.categoria === "DENPs" ? (
                            <>
                                <p className="card-header-title jsoft-card-titulo-index  jsoft-title-md jsoft-cyan jsoft-pad-0">
                                    {name}
                                </p>
                            </>
                        ) : (
                            ""
                        )}
                    </header>
                    <div className="card-content jsoft-grey-light-bg">
                        <div className="contenedor ">
                            {this.props.tag === "doc_recientes" ? (
                                <>
                                    <div className="field has-addons">
                                        <div className="control">
                                            <input
                                                className="input jsoft-search-input"
                                                type="text"
                                                placeholder=""
                                                size="30"
                                                onChange={this.handleBusqueda}
                                                id="txt_ncc"
                                                autoComplete="off"
                                            ></input>
                                        </div>
                                        <div className="control">
                                            <button
                                                className="button grisbtn jsoft-search-button"
                                                onClick={this.buscar_simple}
                                            >
                        <span className="pr-2">
                          {this.props.language("expor_buscar")}
                        </span>
                                                <i className="fas fa-search"></i>
                                            </button>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                ""
                            )}
                            <table>
                                <tbody>{this.state.listaElementos}</tbody>
                            </table>
                        </div>
                    </div>
                    <div className="columns is-centered">
                        <div className="column is-justify-content-center has-text-centered is-four-fifths jsoft-w-100">
                            {this.props.categoria === "Documentos Recientes" ? (
                                <>
                                    <a
                                        className="button is-dark is-fullwidth is-radiusless jsoft-vermas jsoft-green-bg"
                                        href={url}
                                    >
                                        {this.props.language("index_ver")}
                                    </a>
                                </>
                            ) : (
                                ""
                            )}
                            {this.props.categoria === "Documentos Jurídicos" ? (
                                <>
                                    <a
                                        className="button is-dark is-fullwidth is-radiusless jsoft-vermas jsoft-red-bg"
                                        href={url}
                                    >
                                        {this.props.language("index_ver")}
                                    </a>
                                </>
                            ) : (
                                ""
                            )}
                            {this.props.categoria === "DENPs" ? (
                                <>
                                    <a
                                        className="button is-dark is-fullwidth is-radiusless jsoft-vermas jsoft-cyan-bg"
                                        href={url}
                                    >
                                        {this.props.language("index_ver")}
                                    </a>
                                </>
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function Cargando(props) {
    return <div className="is-loading"></div>;
}

function Tablareporte(props) {
    const headp = [];
    const headicon = [];
    let item = 0;
    for (var key in props.data.cites.colums) {
        headp.push(<th key={item++}>{props.data.cites.colums[key]}</th>);
        headicon.push(
            <th key={item++}>
                <img alt={key} src={baseUrl("imagen/cites/" + key + ".png")}/>
            </th>
        );
    }
    const rows = [];
    const total = [];

    for (var key in props.data.cites.rows) {
        var ncolum = 0;
        const ritem = [];

        for (const [hkey, value] of Object.entries(props.data.cites.colums)) {
            if (Object.entries(props.data.cites.rows[key]).length > 0) {
                var temp = 0;
                if (props.data.cites.rows[key][value] !== undefined) {
                    temp = parseInt(props.data.cites.rows[key][value]);
                    ritem.push(
                        <td
                            key={key.toString() + hkey.toString()}
                            className="click"
                            title="Revisar"
                        >
                            <a
                                href={localUrl(
                                    "/reportes/listacites?q2=" + key + "&q5=" + hkey
                                )}
                            >
                                {props.data.cites.rows[key][value]}
                            </a>{" "}
                        </td>
                    );
                } else {
                    ritem.push(<td key={key.toString() + hkey.toString()}>0</td>);
                }
                if (total[ncolum] === undefined) {
                    total[ncolum] = 0;
                }
                total[ncolum] += temp;
                ncolum++;
            } else {
                ritem.push(<td key={key.toString() + hkey.toString()}>0</td>);
            }
        }
        rows.push(
            <tr key={key.toString()}>
                <th>{key}</th>
                {ritem}
            </tr>
        );
    }
    const trtotal = total.map((item, index) => {
        return (
            <td key={index}>
                <strong>{item}</strong>
            </td>
        );
    });

    return (
        <table id="tblApendices" className="table table-index is-size-7-mobile table ">
            <thead className="table-cites-head cites">
                <tr className="table-head-otca">
                    <th colSpan="9" className="subtitle">
                        {props.language("subtitulo_cuadro_paises_miembros")}
                    </th>
                </tr>
                <tr>
                    <th rowSpan="2" className="is-vcentered">
                    </th>
                    {headicon}
                </tr>
                <tr>{headp}</tr>
            </thead>
            <tbody className='cites'>
            {rows}
            <tr className="table-cites-row-last">
                <th>{props.language("home_cant_total", "TOTAL")}</th>
                {trtotal}
            </tr>
            </tbody>
        </table>
    );
}

class InicioIntranet extends Component {
    constructor(props) {
        super(props);

        this.state = {
            cites: false,
            iucn: false,
            datahome: false,
            minidash: false,
            tabactive: "cites",
            listIndicadores: [],
            listYears: [],
            listPaises: [],
        };

        this.centermap = {
            init: {coord: {lat: -14.09367, lng: -62.290177}, zoom: 3.8},
            showminidash: {coord: {lat: 7.09367, lng: -62.290177}, zoom: 3.8},
        };
    }

    setDataPage = () => {
        this.props.set_datapage({
            titulo: "",
            fe_itemselect: "home", //clave de item del menu frontend que se debe activar ,
            isbackend: false,
            breadcrumb: [],
        });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        //console.log('ENLACES',prevProps.countDataPage, this.props.countDataPage)
        if (100 === +this.props.countDataPage) {
            this.setDataPage();
        }
    }

    componentDidMount() {
        this.setDataPage();

        this.generarcolumbar();
        axios.get(baseUrl(`cites/reportes/datahome`)).then((res) => {
            this.initpage(res.data);
        });
        var urlesperandom = baseUrl(`cites/reportes/getespecierandom`);
        axios.get(urlesperandom).then((res) => {
            this.agregarrandomespecies(res.data);
        });
    }

    generarcolumbar() {
        //console.log(columna1)
        let columnaItem = (
            <div className="columns">
                <ColumnScrollBar
                    categoria="Documentos Recientes"
                    tag="doc_recientes"
                    key={Math.random().toString(36).substr(2, 9)}
                />
                <ColumnScrollBar
                    categoria="Documentos Jurídicos"
                    key={Math.random().toString(36).substr(2, 9)}
                />
                <ColumnScrollBar
                    categoria="DENPs"
                    key={Math.random().toString(36).substr(2, 9)}
                />
            </div>
        );

        this.setState({
            columnaBar: columnaItem,
        });
    }

    agregarrandomespecies(data) {
        console.log(data);

        this.setState({
            itemespecie: data,
        });
    }

    initpage(result) {
        this.setState({
            datahome: {cites: result.cites, iucn: result.iucn},
        });
        //this.genenar_dataMinidash()
    }

    genenar_dataMinidash = (id = "all") => {
        console.log("genenar_dataMinidash");
        var datamindash = {
            cite: 0,
            iucn: 0,
            char_cite: [
                [this.props.language("index_apendicecites"), "Total de especies"],
            ],
            char_iucn: [
                [this.props.language("index_categoriacites"), "Total de especies"],
            ],
        };
        const crows = this.state.datahome.cites.rows;
        const rrows = this.state.datahome.iucn.rows;
        const ccolums = this.state.datahome.cites.colums;
        const rcolums = this.state.datahome.iucn.colums;
        console.log(crows, rrows, ccolums, rcolums);
        var name = "";
        for (let key in crows) {
            console.log("vvv", key);
            let tmp = 0;
            for (const [hkey, value] of Object.entries(ccolums)) {
                console.log("ppp", Object.entries(crows[key]));
                if (Object.entries(crows[key]).length > 0) {
                    let temp = 0;
                    if (
                        crows[key][value] !== undefined &&
                        (id === "all" || id === +hkey)
                    ) {
                        temp = parseInt(crows[key][value]);
                        if (id === +hkey) {
                            name = value;
                        }
                    }

                    datamindash["cite"] += temp;
                    tmp += temp;
                }
            }
            datamindash["char_cite"].push([key, tmp]);
        }
        for (let key in rrows) {
            let tmp = 0;
            for (const [hkey, value] of Object.entries(rcolums)) {
                if (Object.entries(rrows[key]).length > 0) {
                    let temp = 0;

                    if (
                        rrows[key][value] !== undefined &&
                        (id === "all" || id === +hkey)
                    ) {
                        temp = parseInt(rrows[key][value]);
                        if (id === +hkey) {
                            name = value;
                        }
                    }

                    datamindash["iucn"] += temp;
                    tmp += temp;
                }
            }
            datamindash["char_iucn"].push([key, tmp]);
        }

        datamindash["title"] =
            id === "all"
                ? " Reporte de la Base de datos"
                : this.props.language("index_reportede") + " " + name;


        this.setState({
            minidash: datamindash,
        });
    };

    createInfoWindow(e, map) {
        const infoWindow = new window.google.maps.InfoWindow({
            content:
                '<div class="card card-index">' +
                '<header class="card-header-index ">' +
                '<p class="card-header-title has-text-white">' +
                this.props.language("index_especiamenazada") +
                "</p>" +
                "</header>" +
                '<div class="card-content card-content-index has-text-left">' +
                '<div class=""><strong>345</strong> Especies</div>' +
                "</div>" +
                "</div>",
            position: {lat: e.latLng.lat(), lng: e.latLng.lng()},
        });

        infoWindow.open(map);
    }

    onMapLoad = (map) => {
        axios.get(baseUrl(`cites/reportes/datahomemap`)).then((res) => {
            this.setState({
                listIndicadores: res.data.indicadores,
                listYears: res.data.years,
                listPaises: res.data.paises,
            });
            const paises = [
                {id: 1, lat: -12.238178, lng: -66.357475, name: "Bolovia"},
                {id: 2, lat: -7.749252, lng: -55.942436, name: "Brasil"},
                {id: 3, lat: 2.145541, lng: -71.738419, name: "Colombia"},
                {id: 4, lat: -1.03831, lng: -76.684624, name: "Ecuador"},
                {id: 5, lat: 6.156781, lng: -59.548698, name: "Guyana"},
                {id: 6, lat: -8.955776, lng: -74.113823, name: "Perú"},
                {id: 7, lat: 2.970312, lng: -55.942436, name: "Surinam"},
                {id: 8, lat: 3.211659, lng: -65.676322, name: "Venezuela"},
            ];
            // map.data.loadGeoJson("Limite_biogeografico_Amz_v3.json");
            map.data.setStyle({
                fillColor: "green",
                strokeColor: "#ffffff",
                strokeWeight: 2,
            });

            for (var item in paises) {
                const icono = {
                    url: baseUrl("imagen/cites/" + paises[item]["id"] + ".png"), // url
                    scaledSize: new window.google.maps.Size(30, 30), // scaled size
                    origin: new window.google.maps.Point(0, 0), // origin
                    anchor: new window.google.maps.Point(12, 0), // anchor
                };
                const marker = new window.google.maps.Marker({
                    position: {lat: paises[item]["lat"], lng: paises[item]["lng"]},
                    map: map,
                    title: "Precione para ver el reporte de " + paises[item]["name"],
                    icon: icono,
                    idpais: paises[item]["id"],
                });
                marker.addListener("click", (e) => {
                    //this.createInfoWindow(e, map)
                    this.genenar_dataMinidash(marker.get("idpais"));
                    map.setCenter({lat: 7.09367, lng: -62.290177});
                });
            }
        });
    };

    COptionsIndicadores = () => {
        return this.state.listIndicadores.map((item, index) => (
            <option key={index} value={item.key}>
                {item.title}
            </option>
        ));
    };
    COptionsYears = () => {
        return this.state.listYears.map((item, index) => (
            <option key={index} value={item}>
                {item}
            </option>
        ));
    };
    COptionsPaises = () => {
        return this.state.listPaises.map((item, index) => (
            <option key={index} value={item.id}>
                {item.name}
            </option>
        ));
    };
    OnChangeFilter = () => {
    };

    render() {
        const TableComponent = this.state.datahome ? Tablareporte : Cargando;
        return (
            <section className="section is-main-section mt-0  px-0 main-section-cites">
                <div className="title">
                    <img
                        className="logo-cites"
                        src="https://oraotca.org/wp-content/uploads/2022/12/cites-1.png"
                        alt=""/>
                    <h1>{this.props.language("titulo_principal", "MÓDULO CITES")}</h1>
                </div>
                <div className="columns">
                    <div className="column space-between subtitle-cites">
                        <h2>{this.props.language("subtitulo_que_es_cites","¿Qué es la CITES?")}</h2>
                        <p>{this.props.language("descripcion_que_es_cites_p1")}</p>
                        <p>{this.props.language("descripcion_que_es_cites_p2")}</p>
                        <p>{this.props.language("descripcion_que_es_cites_p3")}</p>
                        <p className="download">
                            <a href="https://cites.org/esp/disc/text.php">
                                <i className="fas fa-download green"></i> {this.props.language("descripcion_que_es_cites_p4_link")}
                            </a>
                        </p>
                    </div>
                    <div className="column">
                        <img
                            src="https://oraotca.org/wp-content/uploads/2022/12/tucan-cites.png"
                        />
                    </div>
                </div>
                <div className="subtitle-cites">
                    <h2>{this.props.language("subtitulo_quien_forma_parte_cites")}</h2>
                </div>
                <div className="columns">
                    <div className="column p-0">
                        <img
                            src="https://oraotca.org/wp-content/uploads/2022/12/felino-cites.png"
                            alt=""/>
                    </div>
                </div>
                <div className="columns orange-white">
                    <div className="column p-50">
                        <p>{this.props.language("descripcion_quien_forma_parte_cites_p1")}</p>

                    </div>
                    <div className="column p-50">
                        <p>{this.props.language("descripcion_quien_forma_parte_cites_p2")}</p>
                    </div>
                </div>
                <div className="subtitle-cites">
                    <h2>{this.props.language("subtitulo_que_cuales_apendices_convencion")}</h2>
                </div>
                <div className="columns">
                    <div className="column">
                        <p>{this.props.language("descripcion_que_cuales_apendices_convencion_p1")}</p>

                    </div>
                    <div className="column align-end">
                        <p className="download">
                            <a href="https://cites.org/esp/app/appendices.php">
                                <i className="fas fa-download green"></i>{this.props.language("descripcion_que_cuales_apendices_convencion_p2")}
                            </a>
                        </p>

                    </div>
                </div>
                {/*Apendices*/}
                <div className="columns mt-5 appendix">
                    <div className="column p-0 bg-green">
                        <img
                            src="https://oraotca.org/wp-content/uploads/2022/12/rana-apendice1.png"
                            alt=""/>
                        <div className="columns align-items-center no-figure">
                            <div className="column is-5 text-center subtitle">
                                <h3>{this.props.language("subtitulo_apendice1")}</h3>
                            </div>
                            <div className="column is-6 pr-70 pl-70 description">
                                <p>{this.props.language("descripcion_apendice1_p1")}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="columns appendix">

                    <div className="column p-0 bg-skyBlue">
                        <img
                            src="https://oraotca.org/wp-content/uploads/2022/12/loros-apendice2.png"
                            alt=""/>
                        <div className="columns align-items-center no-figure">
                            <div className="column is-5 text-center subtitle">
                                <h3>{this.props.language("subtitulo_apendice2")}</h3>
                            </div>
                            <div className="column is-6 pr-70 pl-70 description">
                                <p>{this.props.language("descripcion_apendice2_p1")}</p>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="columns appendix">
                    <div className="column p-0 bg-orange">
                        <img src="https://oraotca.org/wp-content/uploads/2022/12/pantano-apendice3.png" alt=""/>
                        <div className="columns align-items-center no-figure">
                            <div className="column is-5 text-center subtitle">
                                <h3>{this.props.language("subtitulo_apendice3")}</h3>
                            </div>
                            <div className="column is-6 pr-70 pl-70 description">
                                <p>{this.props.language("descripcion_apendice3_p1")}</p>
                                <p className="pt-20">{this.props.language("descripcion_apendice3_p2")}</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/*Fin Apendices*/}

                {/*Numeros Apendices*/}

                <div className="subtitle-cites orange">
                    <h2>{this.props.language("subtitulo_numero_cites_apendice")}</h2>
                </div>

                <div className="columns">
                    <div className="column is-5">
                        <p>{this.props.language("descripción_numero_cites_apendice_p1")}</p>
                    </div>
                </div>

                <div className="columns is-centered">
                    <div className="column is-8 cites-apendice">
                        <img
                            src={this.props.language("descripción_numero_cites_apendice_img")}
                            alt=""/>
                    </div>
                    <div className="column is-4 space-between">
                        <div className="column is-11 is-offset-1">
                            <h4 className="green">{this.props.language("subtitulo_apendice1")} (3%) </h4>
                            <p>{this.props.language("descripción_numero_cites_apendice1_p1")}</p>
                            <p>{this.props.language("descripción_numero_cites_apendice1_p2")}</p>
                        </div>
                        <div className="column is-11 is-offset-1">
                            <h4 className="skyBlue">{this.props.language("subtitulo_apendice2")} (97%) </h4>
                            <p>{this.props.language("descripción_numero_cites_apendice2_p1")}</p>
                            <p className="pt-10">{this.props.language("descripción_numero_cites_apendice2_p2")}</p>
                        </div>
                        <div className="column is-11 is-offset-1">
                            <h4 className="orange">{this.props.language("subtitulo_apendice3")} (1%) </h4>
                            <p>{this.props.language("descripción_numero_cites_apendice3_p1")}</p>
                        </div>
                    </div>
                </div>

                <div className="columns box-black">
                    <div className="column is-4 bg-black c-white">
                        <p className="p-25">{this.props.language("descripción_numero_cites_apendice_p2_negro")}</p>
                    </div>
                    <div className="column is-8 align-end">
                        <p>Fuente :
                            <a href={this.props.language("descripción_numero_cites_apendice_link")}>
                                {this.props.language("descripción_numero_cites_apendice_link")}
                            </a>
                        </p>

                    </div>
                </div>

                {/*Fin Numeros Apendices*/}

                <div className="subtitle-cites green">
                    <h2>{this.props.language("subtitulo_numero_especies_cites_paises")}</h2>
                </div>

                <div className="columns is-gapless">
                    <div className="column is-8 table-container">
                        <TableComponent language={this.props.language} data={this.state.datahome}/>

                    </div>

                    <div className="column is-4 section-indicadores-maps">
                        {this.state.minidash ? (
                            <div className="indicadores-home pr-5">
                                <div className="card m-2 p-2">
                                    <div className="card-content p-3">
                                        <div className="columns pb-0 mb-0">
                                            <div className="column is-4">
                                                <h3 className="title is-size-6 ">
                                                    {this.state.minidash.title
                                                        ? this.state.minidash.title
                                                        : ""}
                                                </h3>
                                                {this.state.minidash.cite ? (
                                                    <div className="is-widget-label">
                                                        <h1 className="title is-size-4 has-text-primary">
                                                            {this.state.minidash.cite}
                                                        </h1>
                                                        <h3 className="subtitle is-spaced is-size-6">
                                                            {this.props.language("index_especiesCites")}
                                                        </h3>
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                                {this.state.minidash.iucn ? (
                                                    <div className="is-widget-label mt-3">
                                                        <h1 className="title is-size-4 has-text-danger">
                                                            {this.state.minidash.iucn}
                                                        </h1>
                                                        <h3 className="subtitle is-spaced is-size-6">
                                                            {this.props.language("index_especiesIucn")}
                                                        </h3>
                                                    </div>
                                                ) : (
                                                    ""
                                                )}
                                            </div>
                                            <div className="column is-8 pt-0">
                                                <div className="tabs is-right">
                                                    <ul>
                                                        <li
                                                            className={
                                                                this.state.tabactive === "cites"
                                                                    ? "is-active"
                                                                    : ""
                                                            }
                                                        >
                                                            <a
                                                                onClick={(e) =>
                                                                    this.setState({tabactive: "cites"})
                                                                }
                                                            >
                                                                {this.props.language("index_graficocites")}
                                                            </a>
                                                        </li>
                                                        <li
                                                            className={
                                                                this.state.tabactive === "iucn"
                                                                    ? "is-active"
                                                                    : ""
                                                            }
                                                        >
                                                            <a
                                                                onClick={(e) =>
                                                                    this.setState({tabactive: "iucn"})
                                                                }
                                                            >
                                                                {this.props.language("index_graficouicn")}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="columns pb-0 mb-0">
                                                    {this.state.minidash.cite &&
                                                    this.state.tabactive === "cites" ? (
                                                        <div className="column mt-0 pt-0">
                                                            <Chart
                                                                width={"180px"}
                                                                height={"200px"}
                                                                chartType="PieChart"
                                                                loader={<div>Loading Chart</div>}
                                                                data={this.state.minidash.char_cite}
                                                                options={{
                                                                    legend: {
                                                                        position: "bottom",
                                                                        textStyle: {fontSize: 9},
                                                                        maxLines: 3,
                                                                    },
                                                                    pieSliceText: "percentage",

                                                                    pieStartAngle: 100,
                                                                }}
                                                                rootProps={{"data-testid": "1"}}
                                                            />
                                                        </div>
                                                    ) : (
                                                        ""
                                                    )}
                                                    {this.state.minidash.iucn &&
                                                    this.state.tabactive === "iucn" ? (
                                                        <div className="column mt-0 pt-0">
                                                            <Chart
                                                                width={"180px"}
                                                                height={"200px"}
                                                                chartType="PieChart"
                                                                loader={<div>Loading Chart</div>}
                                                                data={this.state.minidash.char_iucn}
                                                                options={{
                                                                    legend: {
                                                                        position: "bottom",
                                                                        textStyle: {fontSize: 9},
                                                                        maxLines: 3,
                                                                    },
                                                                    pieSliceText: "percentage",
                                                                    pieStartAngle: 100,
                                                                }}
                                                                rootProps={{"data-testid": "1"}}
                                                            />
                                                        </div>
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}
                        <MapGoogle
                            id="myMap"
                            options={{
                                center: this.state.minidash
                                    ? this.centermap.showminidash.coord
                                    : this.centermap.init.coord,
                                zoom: 3.3,
                                disableDefaultUI: true,
                                styles: estilosGoogleMaps(),
                            }}
                            onMapLoad={this.onMapLoad}
                            createInfoWindow={this.createInfoWindow}
                            style={{width: "100%", height: 565}}
                            genenar_dataMinidash={this.genenar_dataMinidash}
                        />
                    </div>
                </div>

                <div className="subtitle-cites orange">
                    <h2>{this.props.language("subtitulo_como_funciona_cites")}</h2>
                </div>

                <div className="columns">
                    <div className="column p-0">
                        <img className="image"
                            src="https://oraotca.org/wp-content/uploads/2022/12/loro-cites.png"/>
                    </div>
                    <div className="column center subtitle bg-skyBlue c-white">
                        <p className="p-40">
                            {this.props.language("descripcion_como_funciona_cites_p1")}
                        </p>
                        <p className="p-40">
                            {this.props.language("descripcion_como_funciona_cites_p2")}
                        </p>
                        <p className="p-40">
                            {this.props.language("descripcion_como_funciona_cites_p3")}
                        </p>
                    </div>
                </div>

                <div className="subtitle-cites orange">
                    <h2>{this.props.language("subtitulo_quienes_son_autoridades")}</h2>
                </div>

                <div className="columns is-gapless">
                    <div className="column ">
                        <div className="card jsoft-bd-0 bg-skyBlue">
                            <div className="card-image mt-25">
                                    <img
                                        src="https://oraotca.org/wp-content/uploads/2022/12/bolivia-1.png"
                                        alt=""/>
                            </div>
                            <div className="card-content country">
                                <a href=" https://oraotca.org/cites/pages/autoridades?&type=29&pais=1">

                                <h3 className="subtitle">{this.props.language("descripción_quienes_son_autoridades_pais_bolivia")}</h3>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="column ">
                        <div className="card jsoft-bd-0 bg-skyBlue">
                            <div className="card-image mt-25">
                                <img
                                    src="https://oraotca.org/wp-content/uploads/2022/12/brasil-1.png"
                                    alt=""/>

                            </div>
                            <div className="card-content country">
                                <a href="https://oraotca.org/cites/pages/autoridades?&type=29&pais=2">

                                <h3 className="subtitle">{this.props.language("descripción_quienes_son_autoridades_pais_brasil")}</h3>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="card jsoft-bd-0 bg-skyBlue">
                            <div className="card-image mt-25">
                                    <img
                                        src="https://oraotca.org/wp-content/uploads/2022/12/colombia-1.png"
                                        alt=""/>
                            </div>
                            <div className="card-content country">
                                <a href="https://oraotca.org/cites/pages/autoridades?&type=29&pais=3">
                                    <h3 className="subtitle">{this.props.language("descripción_quienes_son_autoridades_pais_colombia")}</h3>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="card jsoft-bd-0 bg-skyBlue">
                            <div className="card-image mt-25">
                                <img
                                    src="https://oraotca.org/wp-content/uploads/2022/12/ecuador-1.png"
                                    alt=""/>
                            </div>
                            <div className="card-content country">
                                    <a href=" https://oraotca.org/cites/pages/autoridades?&type=29&pais=4">
                                        <h3 className="subtitle">{this.props.language("descripción_quienes_son_autoridades_pais_ecuador")}</h3>
                                    </a>
                            </div>
                        </div>
                    </div>
                    <div className="column ">
                        <div className="card jsoft-bd-0 bg-skyBlue">
                            <div className="card-image mt-25">
                                <img
                                src="https://oraotca.org/wp-content/uploads/2022/12/guiana-1.png"
                                alt=""/>

                            </div>
                            <div className="card-content country">
                                <a href="https://oraotca.org/cites/pages/autoridades?&type=29&pais=5">
                                <h3 className="subtitle">{this.props.language("descripción_quienes_son_autoridades_pais_guyana")}</h3>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="column ">
                        <div className="card jsoft-bd-0 bg-skyBlue">
                            <div className="card-image mt-25">
                                <img
                                    src="https://oraotca.org/wp-content/uploads/2022/12/peru-1.png"
                                    alt=""/>

                            </div>
                            <div className="card-content country">
                                <a href="https://oraotca.org/cites/pages/autoridades?&type=29&pais=6">
                                    <h3 className="subtitle">{this.props.language("descripción_quienes_son_autoridades_pais_peru")}</h3>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="card jsoft-bd-0 bg-skyBlue">
                            <div className="card-image mt-25">
                                <img
                                    src="https://oraotca.org/wp-content/uploads/2022/12/suriname-1.png"
                                    alt=""/>
                            </div>
                            <div className="card-content country">
                                <a href="https://oraotca.org/cites/pages/autoridades?&type=29&pais=7">
                                    <h3 className="subtitle">{this.props.language("descripción_quienes_son_autoridades_pais_suriname")}</h3>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="card jsoft-bd-0 bg-skyBlue">
                            <div className="card-image mt-25">
                                <img
                                    src="https://oraotca.org/wp-content/uploads/2022/12/venezuela-1.png"
                                    alt=""/>
                            </div>
                            <div className="card-content country">
                                <a href="https://oraotca.org/cites/pages/autoridades?&type=29&pais=8">
                                <h3 className="subtitle">{this.props.language("descripción_quienes_son_autoridades_pais_venezuela")}</h3>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>


                {/*Operaciones e Instrumentos*/}
                <div className="subtitle-cites">
                    <h2>{this.props.language("subtitulo_operaciones_instrumentos_cites")} </h2>
                </div>
                <div className="columns">
                    <div className="column ">
                        <div className="card jsoft-bd-0 links bg-green">
                            <div className="card-image mt-25">
                                <img
                                    src="https://oraotca.org/wp-content/uploads/2022/12/trafico-ilegal-pie.png"
                                    alt=""/>
                            </div>
                            <div className="card-content">
                                <a href="/trafico-ilegal">
                                    <h3 className="title-2">{this.props.language("descripción_operaciones_instrumentos_cites_trafico")} </h3>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="card jsoft-bd-0 links bg-green">
                            <div className="card-image mt-25">
                                <img
                                    src="https://oraotca.org/wp-content/uploads/2022/12/instrumentos-pie.png"
                                    alt=""/>
                            </div>
                            <div className="card-content">
                                <a href="/instrumentos">
                                    <h3 className="title-2">{this.props.language("descripción_operaciones_instrumentos_cites_instrumentos")} </h3>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="card jsoft-bd-0 links bg-green">
                            <div className="card-image mt-25">
                                <img
                                    src="https://oraotca.org/wp-content/uploads/2022/12/importacion-pie.png"
                                    alt=""/>
                            </div>
                            <div className="card-content">
                                <a href="/exportaciones-importaciones">
                                    <h3 className="title-2">{this.props.language("descripción_operaciones_instrumentos_cites_import_export_1")}</h3>
                                    <h3 className="title-2">{this.props.language("descripción_operaciones_instrumentos_cites_import_export_2")}</h3>

                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="column">
                        <div className="card jsoft-bd-0 links bg-green">
                            <div className="card-image mt-25 ">
                                <img
                                    src="https://oraotca.org/wp-content/uploads/2022/12/actores-pie.png"
                                    alt=""/>
                            </div>
                            <div className="card-content">
                                <a href="/actores">
                                    <h3 className="title-2">{this.props.language("descripción_operaciones_instrumentos_cites_actores")} </h3>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Fin Operaciones e Instrumentos*/}

            </section>
        );
    }
}

const ElementoTablaScroll = connect(getLanguage, {set_datapage, SetLanguage})(
    ElementoTablaScrollX
);
const ColumnScrollBar = connect(getLanguage, {set_datapage, SetLanguage})(
    ColumnScrollBarX
);
export default connect(getLanguage, {set_datapage, SetLanguage})(
    InicioIntranet
);
